import React, { useState } from 'react';
import Core from '@adyen/adyen-web/dist/types/core';
import {
  PaymentProvider,
  PaymentState,
  V12PaymentData,
} from 'components/commercetools-ui/organisms/checkout/provider/payment/types';

export const AdyenContext = React.createContext<PaymentProvider>({} as PaymentProvider);

const AdyenPaymentProvider = ({ children }: React.PropsWithChildren) => {
  //custom added
  const [adyenCheckoutInstance, setAdyenCheckoutInstance] = useState<Core | null>(null);
  const [adyenCheckoutInstanceState, setAdyenCheckoutInstanceState] = useState<PaymentState | null>(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string | null>(null);
  const [paymentStatus, setPaymentStatus] = useState<string>('');
  const [processing, setProcessing] = useState(false);
  const [isOverlayActive, setIsOverlayActive] = useState(false);
  const [isPaymentDataValid, setIsPaymentDataValid] = useState(false);
  const [v12PaymentData, setV12PaymentData] = useState<V12PaymentData | null>(null);
  const [mountedComponent, setMountedComponent] = useState();
  const [paymentSession, setPaymentSession] = useState();

  return (
    <AdyenContext.Provider
      value={{
        //custom added
        processing,
        setProcessing,
        adyenCheckoutInstance,
        setAdyenCheckoutInstance,
        adyenCheckoutInstanceState,
        setAdyenCheckoutInstanceState,
        selectedPaymentMethod,
        setSelectedPaymentMethod,
        paymentStatus,
        setPaymentStatus,
        setIsOverlayActive,
        isOverlayActive,
        isPaymentDataValid,
        setIsPaymentDataValid,
        v12PaymentData,
        setV12PaymentData,
        setMountedComponent,
        mountedComponent,
        paymentSession,
        setPaymentSession,
      }}
    >
      {/* {isOverlayActive && <Overlay />}
      <div
        id="threeDS2-container"
        className="fixed left-1/2 top-1/2 z-[999] -translate-x-1/2 -translate-y-1/2 bg-white"
      /> */}
      {children}
    </AdyenContext.Provider>
  );
};

export default AdyenPaymentProvider;
